import { render, staticRenderFns } from "./CancelLove.vue?vue&type=template&id=994747fc&scoped=true&"
import script from "./CancelLove.vue?vue&type=script&lang=js&"
export * from "./CancelLove.vue?vue&type=script&lang=js&"
import style0 from "./CancelLove.vue?vue&type=style&index=0&id=994747fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994747fc",
  null
  
)

export default component.exports